<template>
  <div class="app">
    <div v-if="isAppIdle" class="idle-warning">{{ timer_message }}  Please click to continue.</div>
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>

    <AppFooter/>
  </div>
</template>

<script>
  import nav from '../_nav'
  import { Header as AppHeader, Sidebar, Footer as AppFooter, Breadcrumb } from '../components/'

  export default {
    name: 'full',
    components: {
      AppHeader,
      Sidebar,
      AppFooter,
      Breadcrumb
    },

    data () {
      return {
        nav: nav.items,
        tenant: '',
        idleMessage: '',
        timer_seconds: 60,
        timer_length: 60,
        timer_message: '',
        timer_active: false,
        timer_interval: null
      }
    },
    methods: {
      switchTab (tab) {
        this.currentTab = tab
      },
      updateTenant () {
        this.tenant = this.$store.state.tenant
      },
      startTimer () {
        this.interval = setInterval(this.countDown, 1000)
      },
      countDown () {
        if (!this.timer_active) {
          this.timer_active = true
        } else if (this.timer_seconds > 0) {
          this.timer_seconds = this.timer_seconds - 1
          this.timer_message = 'You will be logged off in ' + this.timer_seconds + ' seconds.'
        } else {
          clearInterval(this.interval)
          this.timer_active = false
          this.timerDone()
        }
      },
      showIdleWarning () {
        this.startTimer()
      },
      timerDone () {
        this.$router.push({ name: 'Logout' })
      }
    },
    computed: {
      name () {
        return this.$route.name
      },
      list () {
        return this.$route.matched
      },
      authenticated () {
        return this.$store.getters.cognitoAuthenticated
      },
      created () {
        this.updateTenant()
      }
    },
    onIdle () {
      this.showIdleWarning()
    },
    onActive () {
      clearInterval(this.interval)
      this.timer_seconds = this.timer_length
      this.$store.dispatch('refreshSession').then(() => {
      }).catch((err) => {
        this.$raven.captureException(err)
        console.log('error: ' + err)
      })
    }
  }
</script>

<style>
  .app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .app-header.navbar .navbar-brand.smart {
    background-size: 145px auto;
    background-image: url('../assets/tenant/smart/logo.png');
  }

  .app-header.navbar .navbar-brand.msb {
    background-size: 380px auto;
    background-image: url('../assets/tenant/msb/logo.png');
    width: 380px;
  }

  @media (max-width: 991px) {
    .app-header.navbar .navbar-brand.msb {
      background-size: 320px auto;
      width: 320px;
      margin-left: -140px;
    }
  }

  .idle-warning {
    position: fixed;
    z-index:10000;
    top: 0;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 1.5em;
    height: auto;
    padding: 20px;
    color: white;
    font-weight: bold;
    border-bottom: 1px solid black;
    background: rgba(239,197,195,1);
    background: -moz-linear-gradient(top, rgba(239,197,195,1) 0%, rgba(210,82,75,1) 38%, rgba(185,47,39,1) 51%, rgba(241,146,142,1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(239,197,195,1)), color-stop(38%, rgba(210,82,75,1)), color-stop(51%, rgba(185,47,39,1)), color-stop(100%, rgba(241,146,142,1)));
    background: -webkit-linear-gradient(top, rgba(239,197,195,1) 0%, rgba(210,82,75,1) 38%, rgba(185,47,39,1) 51%, rgba(241,146,142,1) 100%);
    background: -o-linear-gradient(top, rgba(239,197,195,1) 0%, rgba(210,82,75,1) 38%, rgba(185,47,39,1) 51%, rgba(241,146,142,1) 100%);
    background: -ms-linear-gradient(top, rgba(239,197,195,1) 0%, rgba(210,82,75,1) 38%, rgba(185,47,39,1) 51%, rgba(241,146,142,1) 100%);
    background: linear-gradient(to bottom, rgba(239,197,195,1) 0%, rgba(210,82,75,1) 38%, rgba(185,47,39,1) 51%, rgba(241,146,142,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#efc5c3', endColorstr='#f1928e', GradientType=0 );
  }
</style>



// WEBPACK FOOTER //
// src/containers/FileStore.vue?a5bcee94